module.exports = __webpack_public_path__ + "img/but.61c426c6.png";